exports.phrases = {
    Landing: {
      header1: 'An information system is as good as the quality of its data.',
      paragraph1: 'Identify is an application for the quality monitoring of the records stored in Institutions\'s information systems.',
      header2: 'Purpose',
      paragraph2: 'The purpose of this application is to provide the ability for direct, easy and complete information about the quality of the data contained in the information systems of Institutions, making the detection of inaccuracies easy and improving the quality of the stored information.',
      header3: 'Ποιούς Αφορά',
      paragraph3: 'This applications aims at people in charge of information systems and the authorized Institution\'s staff.',
      header4: 'What does it offer',
      paragraph4: 'Identify offers easy access to information regarding the quality of the records stored in information systems.',
      header5: '',
      paragraph5: ' The authorized user has the ability to get a quick overview on the data by their access to statistics, while he can get informed about the possible inaccuracies found by checks performed on the corresponding system and perform searches based on the attributes which they are interested in.',
      paragraph6: 'Identify\'s data are properly grouped depending on their characteristics, in order to make the user able to focus to the data which interest him more easily.',
      paragraph7: 'More information about Identify and the access to it can be found at the',
      usersManual: 'User\'s Guide',
      learnMore: 'Learn More',
      login: 'Login',
      overview: 'Statistics'
    },
    overview: "Statistics",
    checks: "Results",
    login: "Login",
    logout: 'Logout',
    contact: 'Contact',
    recordInfo: 'Record Information',
    noMatchingResults: 'No matching results were found',
    errCode: 'Code',
    errDescription: 'Description',
    errType: 'Type',
    errSeverity: 'Severity',
    errFields: 'Fields',
    errValue1: 'Fields 1',
    errValue2: 'Fields 2',
    invalidMobilePhone: 'There is not a valid mobile phone number available',
    usersGuide: 'Identify User\'s Guide',
    accessMailSubject: '<Institution\'s Name> Identify, Account Application',
    runRequestMailSubject: '<Institution\'s Name> : Identify, New Data (SIS) Quality Check Scheduling',
    runRequestMailBody: "The filter with which we want to constrain the inspection of the catalogue data, in an SQL form, f.e.: ",
    runRequestMailClause1: "WHERE enrollmentStatus='active'",
    runRequestMailClause2: "WHERE enrollmentStatus IN ('active', 'interim') AND enrollmentTerm<=4",
    clickToCopy: "Click to copy",
    clickToMail: "Click to send e-mail",
    landingPageTitle: 'Identify - Home',
    loginPageTitle: 'Identify - Login',
    overviewPageTitle: 'Identify - Statistics',
    resultsPageTitle: 'Identify - Results',
    help: 'Help',
    usersGuide1: 'User\'s Guide',
    helpPageTitle: 'Identify - User\'s Guide',
    helpContents: 'Contents',
    helpIntroduction: 'Login',
    helpRecordQuality: 'Records\' Quality',
    helpErrorsPerType: 'Inaccuracies per Type',
    helpErrorsPerField: 'Inaccuracies per Field',
    helpErrorAnalysis: 'Inaccuracies Analysis',
    helpResults: 'Detailed Results',
    helpAuthorization: 'Access to Application',
    helpRunScheduling: 'New Quality Checks Scheduling',
    helpRequirements: 'Prerequisites',
    accessInfo: 'How do I gain access;',
    errorPageTitle: 'Identify',
    web: 'Web',
    phone: 'Phone',
    email: 'E-mail',
    landing: 'Home',
    goal: 'Purpose',
    targetGroup: 'Ποιούς Αφορά',
    fetchErrorMessage: 'Something went wrong!',
    fetchErrorSubtitle: 'Try again later',
    fetchErrorLink: 'Return to Homepage',
    notAuthorizedErrorMessage: 'It seems like you are currently not logged in the application.', 
    downloadFile1: 'To download a file which will contain the analytic results, which occurred upon the checks on the student catalogues of the Institution, ',
    downloadFile2: 'follow the link below',
    fileNotExists1: 'Αυτή την στιγμή δεν είναι διαθέσιμο αρχείο με τα αναλυτικά αποτελέσματα, τα οποία προέκυψαν από τους ελέγχους στο μητρώο φοιτητών του ιδρύματος',
    fileNotExists2: 'Try again later',
    resFileUrlName: 'Αναλυτικά Αποτελέσματα Ελέγχων',
    checksResults: 'Checks\'s Results',
    errorsPerSeverity: "Records\' Quality",
    errorsPerProperty: "Inaccuracies by Field",
    errorsPerType: "Incaccuracies by Type",
    errorAnalysis: "Incaccuracy Analysis",
    faultyRecordsNumber: "Number of Records with Incaccuracies",
    faultsNumber: "Total Number of Inaccuracies",
    resultsFor: "Results for",
    allDepartments: "All Departments",
    overviewInfo: 'In the charts that refer to records, the percentages refer to the records total, while in those which refer to inaccuracies, the percentagages refer to th inaccuracies total',
    lastRun: "Last Check",
    numberOfRecordsChecked: "Number of Checked Records",
    databaseFilter: "Filter Used in the Database",
    recordsThatIncludeErr: "Records which contain at least one of the following inaccuracies",
    recordsThatDontIncludeErr: "Records in which no inaccuracies were found.",
    institution: 'Institution',
    key: 'Password',
    emptyId: 'The Institution\'s name cannot be empty',
    emptyToken: 'The password cannot be empty',
    loginFailed: 'The credentials you provided do not match',
    loginError: 'A problem has occurred, try again later',
    errorTypeHeader: 'Inaccuracies belonging to the above category',
    propertyIdHeader: 'Inaccuracies regarding the above field',
    grades: {
        '0': 'No Inaccuracies',
        '1': 'Inaccuracies of Very Low Severity',
        '2': 'Inaccuracies of Low Severity',
        '3': 'Inaccuracies of Moderate Severity',
        '4': 'Inaccuracies of Considerably High Severity',
        '5': 'Inaccuracies of Very High Severity',
        '6': 'Inaccuracies of Extremely High Severity'
    },
    severityDescriptions: {
        '1': 'Very Low Severity',
        '2': 'Low Severity',
        '3': 'Moderate Severity',
        '4': 'Considerably High Severity',
        '5': 'Very High Severity',
        '6': 'Extremely High Severity',
    },
    errors: {
        '1': 'Unneeded whitespace characters in the citizenship (citizenship) of the National SSN Registry',
        '2': 'Unneeded whitespace characters in the date of birth (birthDate of the National SSN Registry',
        '3': 'Unneeded whitespace characters in the indication of plasmatic birthdate (bdate_istrue) of the National SSN Registry',
        '4': 'Unneeded whitespace characters in the gender (gender) of the National SSN Registry',
        '5': 'Unneeded whitespace characters in the TIN (TIN) of the National SSN Registry',
        '6': 'Unneeded whitespace characters in the last name in greek (lastNameEl) of the National SSN Registry',
        '7': 'Unneeded whitespace characters in the last name in latin (lastNameEn) of the National SSN Registry',
        '301': 'Missmatch of the date of birth (birthDate) due to plasmatic dtae of birth in the National SSN Registry',
        '302': 'Not valid greek TIN (TIN) in the National SSN Registry',
        '303': 'Empty citizenship (citizenship) in the Institution\'s system and the National SSN Registry',
        '304': 'Empty gender (gender) in the Institution\'s system and the National SSN Registry',
        '601': 'Invalid length of the TIN (TIN) in the National SSN Registry',
        '602': 'Not numeric value of the TIN (TIN) in the National SSN Registry',
        '603': 'Empty TIN (TIN) in the National SSN Registry',
        '901': 'Empty citizenship (citizenship) only in the National SSN Registry',
        '902': 'Empty date of birth (birthDate) in the National SSN Registry',
        '903': 'Invalid format of the date of birth (birthDate) in the National SSN Registry',
        '904': 'Unknown value in the indication of plasmatic birthdate field (bdate_istrue) in the National SSN Registry',
        '905': 'Empty gender (gender) in the National SSN Registry while a value different from 0 exists in the gender field in the Institution\'s registry',
        '906': 'Empty last name in greek (lastNameEl) only in the National SSN Registry',
        '1001': 'Mobile phone number (mobilePhone) with the international code "00" instead of "+" in the Institution\'s system',
        '1002': 'Mobile phone number (mobilePhone) without an international code in the Institution\'s system',
        '1101': 'Not normalized mobile phone number (mobilePhone) in the Institution\'s system',
        '1201': 'Unneeded whitespace characters in the SSN (SSN) in the Institution\'s system',
        '1202': 'Unneeded whitespace characters in the SSN issuing counry (SSNCOUNTRY) in the Institution\'s system',
        '1203': 'Unneeded whitespace characters in the citizenship (citizenship) in the Institution\'s system',
        '1204': 'Unneeded whitespace characters in the date of birth (birthDate) in the Institution\'s system',
        '1205': 'Unneeded whitespace characters in the year of birth (birthYear) in the Institution\'s system',
        '1206': 'Unneeded whitespace characters in the gender (gender) in the Institution\'s system',
        '1207': 'Uneeded whitespace characters in the TIN (TIN) n the Institution\'s system',
        '1208': 'Unneeded  whitespace characters in the TIN issuing country (TINCOUNTRY) in the Institution\'s system',
        '1209': 'Unneeded whitespace characters in the last name in greek (lastNameEl) in the Institution\'s system',
        '1210': 'Unneeded whitespace characters in the last name in latin (lastNameEn) in the Institution\'s system',
        '1211': 'Unneeded whitespace characters in the mobile phone numer (mobilePhone) in the Insituution\'s system',
        '1212': 'Unneeded whitespace characters in the username (loginName) in the Institution\'s system',
        '1501': 'Invalid greek TIN (TIN) in the Institution\'s system',
        '1502': 'Not numeric value in the mobile phone number (mobilePhone) in the Institution\'s system',
        '1503': 'Invalid value in the TIN issuing country (TINCOUNTRY) in the Institution\'s system',
        '1505': 'The username (loginName) containes more than one Capital latin character',
        '1801': 'Not filled TIN (TIN) while the TIN issuing country (TINCOUNTRY) is filled in the Institution\'s system',
        '1802': 'Not filled TIN issuing country (TINCOUNTRY) while the TIN (TIN) is filled in the Institution\'s system',
        '1803': 'Invalid length in a greek TIN (TIN) in the Institution\'s system',
        '1804': 'Not numeric value in a greek TIN (TIN) in the Institutions\'s system',
        '1805': 'Empty last name in greek (lastNameEn) in the National SSN Registry',
        '1806': 'Invalid value of the mobile phone number (mobilePhone) in the Institution\'s system',
        '1807': 'Invalid length of the mobile phone number (mobilePhone) in the Institution\'s system',
        '1808': 'Invalid value of the account status (accountStatus) in the Institution\'s system',
        '1809': 'Invalid format of the e-mail address field (extEmail in the Institution\'s system',
        '2101': 'Empty last name in latin (lastNameEn) and last name in greek (lastNameEl) in the National SSN Registry',
        '2401': 'Missmatch between the TINs (TIN) in  the Institution\'s system and the National SSN Registry',
        '2701': 'Invalid greek SSN (SSN) in the Institution\'s system',
        '2702': 'The SSN (SSN) does not match to a record in the National SSN Registry',
        '3001': 'Empty SSN issuing country (SSNCOUNTRY) while the SSN (SSN) is filled in the Institutions\'s system',
        '3002': 'Empty SSN (SSN) while there is a greek SSN issuing counrty (SSNCOUNRY) registered',
        '3301': 'Invalid length of a greek SSN (SSN) in the Institution\'s system',
        '3302': 'Not numeric value of a greek SSN (SSN) in the Institutions System',
        '3303': 'Invalid value of the SSN issuing country (SSNCOUNTRY) in the Institution\'s system',
        '3304': 'Number of characters in the username (loginName) is out of the permitted range',
        '3401': 'The father\'s first name in greek (fatherFirstNameEl) in the Institution\'s system and the father\'s first name in greek in the National SSN Registry are very different from each other',
        '3402': 'The father\'s first name in latin (fatherFirstNameEn) in the Institution\'s system and the father\'s first name in latin in the National SSN Registry are very different from each other',
        '3403': 'The mother\'s first name in greek (fatherFirstNameEl) in the Institution\'s system and the mother\'s first name in greek in the National SSN Registry are very different from each other',
        '3404': 'The mother\'s first name in latin (motherFirstNameEl) in the Institution\'s system and the mother\'s first name in latin in the National SSN Registry are very different from each other',
        '3405': 'Empty father\'s first name in greek (motherFirstNameEn) in the Institution\'s system while it exists in the National SSN Registry',
        '3406': 'Empty father\'s first name in latin (fatherFirstNameEn) in the Institution\'s system while it exists in the National SSN Registry',
        '3407': 'Empty mother\'s first name in greek (motherFirstNameEl) in the Institution\'s system while it exists in the National SSN Registry',
        '3408': 'Empty mother\'s first name in latin (motherFirstNameEn) in the Institution\'s system while it exists in the National SSN Registry',
        '3601': 'Last names in  greek (lastNameEl) match only after the normalization of special characters',
        '3602': 'Last names in greek (lastNameEl) match only after the normalization of separators',
        '3603': 'Last names in latin (lastNameEn) match only after the normalization of special characters',
        '3604': 'Last names in latin (lastNameEn) match only after the normalization of separators',
        '3801': 'The first name in greek (firstNameEl) in the Institution\'s system and the first name in greek in the National SSN Registry are very different from each other',
        '3802': 'The first name in latin (firstNameEn) in the Institutions\'s system and the first name in latin in the National SSN Registry are very different from each other',
        '3803': 'Empty first name in greek (firstNameEl) in the Institution\'s system while it exists in the National SSN Registry',
        '3804': 'Empty first name in latin (firstNameE) in the Instition\'s system while it exists in the National SSN Registry',
        '4001': 'Empty last name in greek (lastNameEl) in the Insitution\'s system while it exists in the National SSN Registry',
        '4101': 'Empty last name in latin (lastNameEn) in the Institution\'s system while it exists in the National SSN Registry',
        '4201': 'Empty citizenship (citizenship) in the Institution\'s system while it exists in the National SSN Registry',
        '4202': 'Empty date of birth (birthDate) in the Institution\'s system while it exists in the National SSN Registry',
        '4203': 'Empty year of birth (birthYear) in the Institution\'s system while it exists in the National SSN Registry',
        '4204': 'Invalid date of birth (birthDate) in the Institution\'s system',
        '4205': 'Invalid year of birth (birthYear) in the Institution\'s system',
        '4206': 'Empty gender (gender) in the Institution\'s system',
        '4207': 'Invalid gender (gender) value in the Institution\'s system',
        '4208': 'Invalid citizenship (citizenship) value in the Institution\'s syste,',
        '4209': 'The username (loginName) contains at least one not permitted character',
        '4501': 'Empty last name in greek (lastNameEl) and empty last name in latin (lastNameEn) in the Institution\'s system',
        '4502': 'Invalid enrollment status (enrollmentStatus) value in the Institution\'s system',
        '4503': 'Invalid enrollment type (enrollmentType) value in the Institution\'s system',
        '4504': 'Empty date of enrollment status modification (enrollmentStatusDate) in the Institution\'s system',
        '4505': 'Invalid format of the date of enrollment status modification (enrollmentStatusDate) in the Institution\'s system',
        '4801': 'Missmatch of the date of birth (birthDate) between the Institution\'s system and the National SSN Registry',
        '5101': 'Missmatch of the citizenship (citizenship) between the Institution\'s system and the National SSN Registry',
        '5102': 'Missmatch of the year of birth (birthYear) between the Institution\'s system and the National SSN Registry',
        '5103': 'Missmatch of the gender (gender) between the Institution\'s system and the National SSN Registry',
        '5104': 'Missmatch of the last name in greek (lastNameEl) between the Institution\'s system and the National SSN Registry',
        '5105': 'Missmatch of the last name in latin (lastNameEn) between the Institution\'s system and the National SSN Registry',
        '5106': 'The first name in greek (firstNameEl) value does not match the corresponding value of another record with the same username (loginName)',
        '5107': 'The first name in latin (firstNameEn) value does not match the corresponding value of another record with the same username (loginName)',
        '5108': 'The last name in greek (lastNameEl) value does not match the corresponding value of another record with the same username (loginName)',
        '5109': 'The last name in latin (lastNameEn) value does not match the corresponding value of another record with the same usernane (loginName)',
        '5110': 'The SSN (SSN) value does not match the corresponding value of another record with the same username (loginName)',
        '5111': 'The SSN issuing country (SSN_COUNTRY) value does not match the corresponding value of another record with the same username (loginName)',
        '5112': 'The TIN (TIN) value does not match the corresponding value of another record with the same username (loginName)',
        '5113': 'The TIN issuing country (TIN_COUNTRY) value does not match the corresponding value of another record with the same username (loginName)',
        '5114': 'The date of birth (birthDate) value does not match the corresponding value of another record with the same username (loginName)',
        '5115': 'The year of birth (birthYear) value does not match the corresponding value of another record with the same username (loginName)',
        '5116': 'The first name in greek (firstNameEl) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5117': 'The first name in latin (firstNameEn) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5118': 'The last name in greek (lastNameEl) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5119': 'The last name in latin (lastNameEn) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5120': 'The SSN (SSN) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5121': 'The SSN issuing country (SSN_COUNTRY) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5122': 'The TIN (TIN) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5123': 'The TIN issuing country (TIN_COUNTRY) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5124': 'The date of birth (birthDate) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5125': 'The year of birth (birthYear) value does not match the corresponding value of another record with the same mobile phone number (mobilePhone)',
        '5126': 'The first name in greek (firstNameEl) value does not match the corresponding value of another record with the same e-mail adress (extEmail)',
        '5127': 'The first name in latin (firstNameEn) value does not match the corresponding value of another record with the same e-mail address (extEmail)',
        '5128': 'The last value in greek (lastNameEl) value does not match the corresponding value of another record with the same e-mail address (extEmail)',
        '5129': 'The last value in latin (lastNameEn) value does not match the corresponding value of another record with the same e-mail address (extEmail)',
        '5130': 'The SSN (SSN) value does not match the corresponding value of another record with the same e-mail address (extEmail)',
        '5131': 'The SSN issuing country (SSN_COUNTRY) value does not match the corresponding value of another record with the same e-mail addess (extEmail)',
        '5132': 'The TIN (TIN) value does not match the corresponding value of another record with the same e-mail address (extEmail)',
        '5133': 'The TIN issuing country (TIN_COUNTRY) value does not match the corresponding value of another record with the same e-mail address (extEmail)',
        '5134': 'The date of birth (birthDate) value does not match the corresponding value of another record with the same e-mail address (extEmail)',
        '5135': 'The year of birth (birthYear) value does not match the corresponding value of another record with the same e-mail addess (extEmail)',

        '5401': 'The Registration Id (registrationID) field in the Institution\'s system contains a value that matches more than one records',
        '5402': 'The System Id (systemID) field in the Institution\'s system contains a value that matches more than one records',

    },
    errorsProperty: {
        'birthdate': 'Date of Birth',
        'birthyear': 'Year of Birth',
        'birthΥear': 'Year of Birth',
        'lastNameEl': 'Last Name in Greek',
        'lastNameEn': 'Last Name in Latin',
        'firstNameEl': 'First Name in Greek',
        'firstNameEn': 'First Name in Latin',
        'fatherFirstNameEl': 'Father\'s First Name in Greek',
        'fatherFirstNameEn': 'Father\'s First Name in Latin',
        'motherFirstNameEl': 'Mother\'s First Name in Greek',
        'motherFirstNameEn': 'Mother\'s First Name in Latin',
        'ssn': 'SSN',
        'tin': 'TIN',
        'ssnCountry': 'SSN Issuing Country',
        'tinCountry': 'TIN Issuing Country',
        'ssncountry': 'SSN Issuing Country',
        'tincountry': 'TIN Issuing Country',
        'gender': 'Gender',
        'citizenship': 'Citizenship',
        'mobilePhone': 'Mobile Phone Number',
        'mobile': 'Mobile Phone Number',
        'bdate_istrue': 'Indication of Plasmatic Birthdate',
        'enrollmentStatus': 'Enrollment Status',
        'enrollmentType': 'Enrollment Type',
        'enrollmentStatusDate': 'Date of Enrollment Status\' Modification',
        'accountStatus': 'Account Status',
        'loginName' : 'Username',
        'systemID': 'System ID',
        'registrationID': 'Registration ID',
        'extEmail': 'E-mail Address'
    },
    errorsType: {
        'trimming': 'Whitespace Characters',
        'normalization': 'Normalization',
        'invalid-format': 'Invalid Format',
        'invalidValue': 'Invalid Value',
        'invalid-value': 'Invalid Value',
        'null-value': 'Null Value',
        'missmatch': 'Missmatch'
    },
    trimmingDesc: 'The field\'s value contain whitespace characters at the beginning or the end',
    normalizationDesc: 'The field\'s value is accurate only after the normalization of diairesis, accent marks or special characters',
    invalidFormatDesc: 'The field\'s value does not follow the proper format',
    invalidValueDesc: 'The field contains a value which not comply to its field',
    nullValueDesc: 'The field is not filled',
    missmatchDesc: 'The field\'s value in the system does not match with the corresponding value in the National SSN Registry',
    Checks: {
        checksResults: 'Checks\' Results',
        recordsWErrors: 'Records with Inaccuracies',
        numOfRecordsWErrors: 'Number of Records containing Inaccuracies',
        downloadResultsFile: 'Download Results\' File',
        numOfErrors: 'Total Number of Inaccuracies',
        noResultsFileAvailable: 'There is not a results\' file available',
        numOfFilteredResults: 'Number of Filtered Results',
        registrationId: 'Registration Id',
        systemId: 'System Id',
        department: 'Department', 
        errorType: 'Inaccuracy Type',
        field: 'Fields',
        severity: 'Severity',
        filters: 'Filters',
        clear: 'Clear',
        errorFilters: 'Error Fields',
        studentFilters: 'Student Fields',
        identifiers: 'Identifiers',
        contact: 'Contact',
        studies: 'Studies',
        names: 'Names',
        account: 'Account',
        personalInfo: 'Personal Info',
        cancel: 'Cancel',
        continue: 'Continue',
        fields: 'Fields',
        errortypes: 'Types',
        departments: 'Departments',
        sortBy: 'Sort By'
    },
    Record: {
        errors: 'Inaccuracies',
        numOfRecordErrors: 'Number of Record Inaccuracies',
        backToResults: 'Back to Results',
        moreData: 'More Data',
        moreRecordData: 'Record Analytical Data',
        close: 'Close',
        notify: 'Notify',
        department: 'Department',
        severity: 'Severity',
        name: 'Full Name',
        identifiers: 'Identifiers',
        contact: 'Contact',
        studies: 'Studies',
        names: 'Names',
        account: 'Account',
        personalInfo: 'Personal Information',
        cancel: 'Cancel',
        continue: 'Continue',
        fields: 'Fields',
        errortypes: 'Types',
        departments: 'Department',
        sortBy: 'Sort By',
        fields: {
            'registrationID': 'Registration Id',
            'systemID': 'System Id',
            'ssn': 'SSN',
            'ssnCountry': 'SSN Issuing Country',
            'tin': 'TIN',
            'tinCountry': 'TIN Issuing Country',
            'lastNameEl': 'Last Name (Greek)',
            'lastNameEn': 'Last Name (Latin)',
            'firstNameEl': 'First Name (Greek)',
            'firstNameEn': 'First Name (Latin)',
            'fatherFirstNameEl': 'Father\'s First Name (Greek)',
            'fatherFirstNameEn': 'Father\'s First Name (Latin)',
            'motherFirstNameEl': 'Mother\'s First Name (Greek)',
            'motherFirstNameEn': 'Mother\'s First Name (Latin)',
            'enrollmentStatus': 'Enrollment Status',
            'enrollmentStatusDate': 'Date of Enrollment Status\' Modification',
            'enrollmentTerm': 'Enrollment Term',
            'enrollmentType': 'Ernollment Type',
            'attendanceType': 'Attendance Type',
            'loginName': 'Username',
            'accountStatus': 'Account Status',
            'extEmail': 'E-mail Address',
            'mobilePhone': 'Mobile Phone Number',
            'birthDate': 'Date of Birth',
            'birthYear': 'Year of Birth',
            'gender': 'Gener',
            'citizenship': 'Citizenship'          
        }
    },
    Dropdown: {
        fields: {
            label: 'Fields',
            all: 'All',
            'birthdate': 'Date of Birth',
            'birthyear': 'Year of Birth',
            'lastNameEl': 'Last Name in Greek',
            'lastNameEn': 'Last Name in Latin',
            'firstNameEl': 'First Name in Greek',
            'firstNameEn': 'First Name in Latin',
            'fatherFirstNameEl': 'Father\'s First Name in Greek',
            'fatherFirstNameEn': 'Father\'s First Name in Latin',
            'motherFirstNameEl': 'Mother\'s First Name in Greek',
            'motherFirstNameEn': 'Mother\'is First Name in Latin',
            'ssn': 'SSN',
            'tin': 'TIN',
            'ssnCountry': 'SSN Issuing Country',
            'tinCountry': 'TIN Issuing Country',
            'ssncountry': 'SSN Issuing Country',
            'tincountry': 'TIN Issuing Country',
            'gender': 'Gender',
            'citizenship': 'Citizenship',
            'mobilePhone': 'Mobile Phone Number',
            'bdate_istrue': 'Indication of Plasmatic Birthdate',
            'enrollmentStatus': 'Enrollment Status',
            'enrollmentType': 'Enrollment Type',
            'enrollmentStatusDate': 'Date of Enrollment Status\' Modification',
            'accountStatus': 'Account Status',
            'loginName' : 'Username',
            'systemID': 'System ID',
            'registrationID': 'Registration ID',
            'extEmail': 'E-mail Address',

            explanations: {
                'birthdate': 'birthDate',
                'birthyear': 'birthYear',
                'lastNameEl': 'lastNameEl',
                'lastNameEn': 'lastNameEn',
                'firstNameEl': 'firstNameEl',
                'firstNameEn': 'firstNameEn',
                'fatherFirstNameEl': 'fatherFirstNameEl',
                'fatherFirstNameEn': 'fatherFirstNameEn',
                'motherFirstNameEl': 'motherFirstNameEl',
                'motherFirstNameEn': 'motherFirstNameEn',
                'ssn': 'SSN',
                'tin': 'TIN',
                'ssnCountry': 'SSN_COUNTRY',
                'tinCountry': 'TIN_COUNTRY',
                'ssncountry': 'SSN_COUNTRY',
                'tincountry': 'TIN_COUNTRY',
                'gender': 'gender',
                'citizenship': 'citizenship',
                'mobilePhone': 'mobilePhone',
                'bdate_istrue': 'bdate_istrue',
                'enrollmentStatus': 'enrollmentStatus',
                'enrollmentType': 'enrollmentType',
                'enrollmentStatusDate': 'enrollmentStatusDate',
                'accountStatus': 'accountStatus',
                'loginName' : 'loginName',
                'systemID': 'systemID',
                'registrationID': 'registrationID',
                'extEmail': 'extEmail',
            }
        },
        errorTypes: {
            'label': 'Types',
            'all': 'All',
            'trimming': 'Whitespace Characters',
            'normalization': 'Normalization',
            'invalid-format': 'Invalid Format',
            'invalidValue': 'Invalid Value',
            'invalid-value': 'Invalid Value',
            'null-value': 'Null Value',
            'missmatch': 'Missmatch'
        },
        severityGroup: {
            'label': 'Severity',
            'all': 'All',
            '1': 'Very Low Severity',
            '2': 'Low Severity',
            '3': 'Moderate Severity',
            '4': 'Considerably High Severity',
            '5': 'Very High Severity',
            '6': 'Extremely High Severity',
        },
        department: {
            'label': 'Department'
        },
        'sortingRecords': {
            'registrationID-hl': 'Registration ID (Descending)',
            'registrationID-lh': 'Registration ID (Ascending)',
            'systemID-hl': 'System ID (Descending)',
            'systemID-lh': 'System ID (Ascending)',
            'department-hl': 'Department (Descending)',
            'department-lh': 'Department (Ascending)',
            'severity-hl': 'Severity (Descending)',
            'severity-lh': 'Severity (Ascending)',
            'label': 'Sort By',
        },
        'sortingErrors': {
            'severity-hl': 'Severity (Descending)',
            'severity-lh': 'Severity (Ascending)',
            'errorCode-hl': 'Inaccuracy Code (Descending)',
            'errorCode-lh': 'Inaccuracy Code (Ascending)',
            'errorType-hl': 'Inaccuracy Type (Descending)',
            'errorType-lh': 'Inaccuracy Type (Ascending)',
            'label': 'Sort By',
        },
        'enrollmentStatusDateType': {
            'period': 'Period',
            'single': 'Day'
        }, 
        'enrollmentTermType': {
            'period': 'Period',
            'single': 'Semester'
        }
    }, 
    Pills: {
        selections: {
            fields: {
                fields: 'Fields',
                all: 'All',
                'birthdate': 'Date of Birth',
                'birthyear': 'Year of Birth',
                'lastNameEl': 'Last Name in Greek',
                'lastNameEn': 'Last Name in Latin',
                'firstNameEl': 'First Name in Greek',
                'firstNameEn': 'First Name in Latin',
                'fatherFirstNameEl': 'Father\'s First Name in Greek',
                'fatherFirstNameEn': 'Father\'s First Name in Latin',
                'motherFirstNameEl': 'Mother\'s First Name in Latin',
                'motherFirstNameEn': 'Mother\'s First Name in Latin',
                'ssn': 'SSN',
                'tin': 'TIN',
                'ssnCountry': 'SSN Issuing Country',
                'tinCountry': 'TIN Issuing Country',
                'ssncountry': 'SSN Issuing Country',
                'tincountry': 'TIN Issuing Country',
                'gender': 'Gender',
                'citizenship': 'Citizenship',
                'mobilePhone': 'Mobile Phone Number',
                'bdate_istrue': 'Indication of Plasmatic Birthdate',
                'enrollmentStatus': 'Enrollment Status',
                'enrollmentType': 'Enrollment Type',
                'enrollmentStatusDate': 'Date of Enrollment Status\' Modification',
                'accountStatus': 'Account Status',
                'loginName' : 'Username',
                'systemID': 'System ID',
                'registrationID': 'Registration ID',
                'extEmail': 'E-mail Address',
            },
            errorTypes: {
                'errorTypes': 'Type',
                'all': 'All',
                'trimming': 'Whitespace Characters',
                'normalization': 'Normalization',
                'invalid-format': 'Invalid Format',
                'invalidValue': 'Invalid Value',
                'invalid-value': 'Invalid Value',
                'null-value': 'Null Value',
                'missmatch': 'Missmatch'
            },
            severityGroups: {
                'severityGroups': 'Severity',
                'all': 'All',
                '1': 'Very Low Severity',
                '2': 'Low Severity',
                '3': 'Moderate Severity',
                '4': 'Considerably High Severity',
                '5': 'Very High Severity',
                '6': 'Extremely High Severity',
            },
        }, 
        fields: {
                'registrationID': 'Registration Id',
                'systemID': 'System Id',
                'ssn': 'SSN',
                'ssnCountry': 'SSN Issuing Country',
                'tin': 'TIN',
                'tinCountry': 'TIN Issuing Country',
                'lastNameEl': 'Last Name (Greek)',
                'lastNameEn': 'Last Name (Latin)',
                'firstNameEl': 'First Name (Greek)',
                'firstNameEn': 'First Name (Latin)',
                'fatherFirstNameEl': 'Father\'s First Name (Greek)',
                'fatherFirstNameEn': 'Father\'s First Name (Latin)',
                'motherFirstNameEl': 'Mother\'s First Name (Greek)',
                'motherFirstNameEn': 'Mother\'s First Name (Latin)',
                'enrollmentStatus': 'Enrollment Status',
                'enrollmentStatusDate': 'Date of Enrollment Status\' Modification',
                'enrollmentStatusDateFrom': 'Date of Enrollment Status\' Modification (From)',
                'enrollmentStatusDateTo': 'Date of Enrollment Status\' Modification (To)',
                'enrollmentType': 'Enrollment Type',
                'enrollmentTerm': 'Enrollment Term',
                'enrollmentTermFrom': 'Enrollment Term (From)',
                'enrollmentTermTo': 'Enrollment Term (To)',
                'attendanceType': 'Attendance Type',
                'loginName': 'Username',
                'accountStatus': 'Account Status',
                'extEmail': 'E-mail Address',
                'mobilePhone': 'Mobile Phone Number',
                'birthDate': 'Date of Birth',
                'birthYear': 'Year of Birth',
                'gender': 'Gender',
                'citizenship': 'Citizenship',
                'departmentID': 'Department',
                'severityGroup': 'Severity'
        }
        
    },
    Filters: {
        'department': 'Department',
        'registrationID': 'Registration Id',
        'systemID': 'System Id',
        'ssn': 'SSN',
        'ssnCountry': 'SSN Issuing Country',
        'tin': 'TIN',
        'tinCountry': 'TIN Issuing Country',
        'lastNameEl': 'Last Name (Greek)',
        'lastNameEn': 'Last Name (Latin)',
        'firstNameEl': 'First Name (Greek)',
        'firstNameEn': 'First Name (Latin)',
        'fatherFirstNameEl': 'Father\'s First Name (Greek)',
        'fatherFirstNameEn': 'Father\'s First Name (Latin)',
        'motherFirstNameEl': 'Mother\'s First Name (Greek)',
        'motherFirstNameEn': 'Mother\'s First Name (Latin)',
        'enrollmentType': 'Enrollment Type',
        'enrollmentStatus': 'Enrollment Status',
        'enrollmentStatusDate': 'Date of Enrollment Status\' Modification',
        'enrollmentStatusDateFrom': 'Date of Enrollment Status\' Modification (From)',
        'enrollmentStatusDateTo': 'Date of Enrollment Status\' Modification (To)',
        'enrollmentTerm': 'Enrollment Term',
        'enrollmentTermFrom': 'Enrollment Term (From)',
        'enrollmentTermTo': 'Enrollment Term (To)',
        'attendanceType': 'Attendance Type',
        'loginName': 'Username',
        'accountStatus': 'Account Status',
        'extEmail': 'E-mail Address',
        'mobilePhone': 'Mobile Phone Number',
        'birthDate': 'Date of Birth',
        'birthYear': 'Date of Year',
        'gender': 'Gender',
        'citizenship': 'Citizenship'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/locale-en.js